<template>
    <div class="einvoice-setup">
        <div class="step-title">{{ $t('get_started.einvoice_setup_title') }}</div>
        <div class="step-description">
            {{ $t('get_started.einvoice_setup_description') }}&nbsp;
            {{ $t('einvoice.api_key_description') }}
        </div>

        <v-text-field
            v-model="form.api_key"
            :label="$t('einvoice.api_key')"
            outlined
            :error-messages="form.$errors.api_key"
            @blur="form.validate('api_key')"
            @input="delete form.$errors.api_key"
        />

        <div class="footer">
            <v-btn
                class="flex-1 mr-3"
                color="#282b38"
                depressed
                @click="skipStep()"
            >
                {{ $t('general.skip') }}
            </v-btn>
            <v-btn
                class="flex-1"
                color="primary"
                depressed
                :disabled="form.$busy"
                :loading="form.$busy"
                @click="enableEinvoices()"
            >
                {{ $t('general.next') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import * as mutationTypes from '@/store/mutationTypes'
import ApiService from '@/services/ApiService'
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        active: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            form: new Form(this, 'form', {
                api_key: null
            })
        };
    },

    validations: {
        form: {
            api_key: { required },
        }
    },

    methods: {
        skipStep() {
            this.$emit('finish');
        },

        /**
         * Enable Einvoices
         */
        async enableEinvoices() {
            if(!this.form.validate()) return;

            const response = await ApiService.post('/einvoice/enable', this.form);
            if(!response.data.success) {
                this.$set(this.form.$errors, 'api_key', [this.$t(`einvoice.error.${response.data.error}`)]);
                return;
            }

            this.$store.commit(mutationTypes.SET_TENANT, { tenant: response.data.tenant });

            this.$emit('finish')
        },
    },
};
</script>

<style lang="scss" scoped>
.einvoice-setup {
    .step-title {
        margin-bottom: 10px;
        font-size: 20px;
    }

    .step-description {
        margin-bottom: 30px;
        font-size: 14px;
        color: #8f9095;
    }

    .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
}
</style>
